import { BigIntish, FromDecimalsOptions } from "../types";
import { fromDecimals } from "./fromDecimals";

export const formatToSignificant = (value: BigIntish, displayDecimals = 4, fromDecimalsOptions?: FromDecimalsOptions) =>
  fromDecimals(value.toString(), { significantDigits: displayDecimals, shouldCommify: true, ...fromDecimalsOptions });
